import React, { SFC } from 'react';
import styled from 'styled-components';

interface TextBlockProps {
    text: string;
    align?: 'left' | 'center' | 'right';
}

const TextBlockWrapper = styled.div`
    text-align: ${(props: Required<Pick<TextBlockProps, 'align'>>) => props.align};
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
`;

const Paragraph = styled.p`
    margin: 0;
`;

export const TextBlock: SFC<TextBlockProps> = ({ text, align = 'center' as 'center' }) => {
    return (
        <TextBlockWrapper align={align}>
            {text.split('\\n').map((line, index) => (
                <Paragraph key={index}>{line}</Paragraph>
            ))}
        </TextBlockWrapper>
    );
};
